

document.addEventListener("DOMContentLoaded", () => {
    new ModalVideo('.js-modal-btn');
    new ModalVideo('.js-modal-btn-vimeo', {channel: 'vimeo'});
});
